import React from 'react';
import { ProcessingAction } from 'types/rest/assetCatalogTypes';
import HttpRequestModal from './Webhooks/HttpRequestModal';
import StateChangeModal from './stateChange/StateChangeModal';
import { Condition } from '../../../../../types/rest/dslTypes';

type WebHookModalProps = {
  processingAction: ProcessingAction;
  onClose: () => void;
  onCreateFinished: () => void;
  txConditions?: Condition[];
};

export enum TriggerTime {
  SPECIFIC = 'specific',
  RANDOM = 'random',
}

const ProcessingActionModal = (props: WebHookModalProps) => {
  const { processingAction } = props;
  switch (processingAction.actionType) {
    case 'STATE_UPDATE':
      return <StateChangeModal key={'stateChangeModal-' + processingAction.id} {...props} />;
    case 'HTTP_CALL':
    case 'WEBHOOK':
      return <HttpRequestModal key={'httpRequestModal-' + processingAction.id} {...props} />;
  }
};

export default ProcessingActionModal;
